<!--
 * @Author: your name
 * @Date: 2020-10-21 11:31:29
 * @LastEditTime: 2021-01-29 13:25:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\views\Home\AdminMember\AdminProduct.vue
-->
<template>
  <div class="popContainer">
    <div id='adminProduct'>
      <el-tabs class="admin_content" v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane name="1" label="产品管理">
          <img src="@/assets/img/product1.png" alt="">
          <!-- <div class="addNewMember editGroup" @click="editGroup">改分组</div>
          <el-table :data="managementData" stripe style="width: 100%">
            <el-table-column type="selection">
            </el-table-column>
            <el-table-column prop="businessTypeName">
              <template slot="header" slot-scope="scope">
                产品
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入产品名称" v-model="productData.businessTypeName" @change="init">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
              </template>
              <template slot-scope="scope">
                <el-link>{{scope.row.businessTypeName}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="businessType">
              <template slot="header" slot-scope="scope">
                业务类型
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入业务类型" v-model="productData.businessType" @change="init">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="traffic">
              <template slot="header" slot-scope="scope">
                访问量
                <img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="handleImg(3)">
              </template>
            </el-table-column>
            <el-table-column prop="productServiceMode">
              <template slot="header" slot-scope="scope">
                主要服务
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入主要服务" v-model="productData.productServiceMode" @change="init">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="createTime">
              <template slot="header" slot-scope="scope">
                创建时间
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入创建时间" v-model="productData.createTime" @change="init">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
                <img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="handleImg(1)">
              </template>
            </el-table-column>
            <el-table-column prop="updateTime">
              <template slot="header" slot-scope="scope">
                更新时间
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入更新时间" v-model="productData.updateTime" @change="init">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
                <img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="handleImg(1)">
              </template>
            </el-table-column>
            <el-table-column prop="previousIncomeMoney" width="250">
              <template slot="header" slot-scope="scope">
                上一年收入（单位：万元）
                <img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="handleImg(2)">
              </template>
            </el-table-column>
            <el-table-column prop="productServiceMode">
              <template slot="header" slot-scope="scope">
                所属公司
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入所属公司" v-model="productData.productServiceMode" @change="init">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-popover popper-class="userInfo_det" placement="bottom" width="100" trigger="click">
                  <p class="content" @click="editAdmin(scope.row)">下架</p>
                  <img slot="reference" class="more" src="@/assets/img/下架.png" alt="">
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="productData.pageNumber" :page-size="productData.pageSize" layout="total, prev, pager, next" :total="totalPage">
          </el-pagination> -->
        </el-tab-pane>
        <el-tab-pane name="2" label="产品分组">
          <img src="@/assets/img/product1.png" alt="">
          <!-- <div class="addNewMember addType" @click="addTypeVisible=true">添加业务类型</div>
          <el-table :data="productGroupData" stripe style="width: 100%">
            <el-table-column prop="businessTypeName">
              <template slot="header" slot-scope="scope">
                业务类型
                <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
                  <el-input placeholder="请输入业务类型" v-model="productData.businessTypeName" @change="init">
                    <img slot="prefix" src="@/assets/img/search.png" alt="">
                  </el-input>
                  <i slot="reference" class="el-icon-caret-bottom arrow"></i>
                </el-popover>
              </template>
              <template slot-scope="scope">
                <el-row class="tabContent">
                  <span>{{scope.row.businessTypeName}}</span>
                  <img src="@/assets/img/edit.png" alt="">
                </el-row>
              </template>
            </el-table-column>
            <el-table-column prop="productNum">
              <template slot="header" slot-scope="scope">
                产品数
                <img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="handleImg(1)">
              </template>

            </el-table-column>
            <el-table-column prop="createTime">
              <template slot="header" slot-scope="scope">
                创建时间
                <img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="handleImg(1)">
              </template>
              <template slot-scope="scope">
                {{$dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss")}}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="groupData.pageNumber" :page-size="groupData.pageSize" layout="total, prev, pager, next" :total="productTotal">
          </el-pagination> -->
        </el-tab-pane>
      </el-tabs>

      <el-dialog title="添加业务类型" :visible.sync="addTypeVisible" width="25%" custom-class="addTypeVisible" @close="closeaddTypeDialog">
        <el-form :model="addTypeForm" status-icon :rules="addTypeRules" ref="addTypeForm" label-width="110px" class="demo-ruleForm">
          <el-form-item label="业务类型名:" prop="typeValue">
            <el-select v-model="addTypeForm.businessName" placeholder="请选择">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addType" class="button add save">保存</el-button>
          <el-button @click="addTypeVisible=false" class="button save">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getProductData, addProductType, getProductType } from '@/api/index'
export default {
  data() {
    return {
      activeName: '1',
      productData: {
        pageNumber: 1,
        pageSize: 5,
        sort: 'desc',
        businessTypeName: '',
        businessType: '',
        productServiceMode: '',
        createTime: '',
        updateTime: ''
      },
      totalPage: 0,
      managementData: [],
      productGroupData: [],
      isRotate: true,
      groupData: {
        pageNumber: 1,
        pageSize: 5,
        businessTypeName: '上海',
        sortFieldType: 1,
        sort: 'desc'
      },
      productTotal: 0,
      addTypeVisible: false,
      typeValue: "",
      typeList: [{
        value: '1',
        label: 'type1'
      }, {
        value: '2',
        label: 'type2'
      }, {
        value: '3',
        label: 'type3'
      }],
      addTypeForm: {
        businessName: ''
      },
      addTypeRules: {
        businessName: [{ required: true, message: '请输入业务类型名', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      if (this.activeName == '1') {
        const { data } = await getProductData(this.productData)
      } else if (this.activeName == '2') {
        const { data } = await getProductType(this.groupData)
        if (data.code !== 0) return
        this.productGroupData = data.productBusinessTypeList
      }

    },
    handleTabClick(tab) {
      if (tab.name == '1') {
        this.activeName = '1'
      } else if (tab.name == '2') {
        this.activeName = '2'
      }
      this.init()
    },
    editGroup() { },
    handleImg(type) {
      if (type == 1) {
        this.isRotate = !this.isRotate
      } else if (type == 2) {
        this.isRotate1 = !this.isRotate1
      } else if (type == 3) {
        this.isRotate2 = !this.isRotate2
      }
      if (this.isRotate) { this.getMemberInfo('desc', type) } else {
        this.getMemberInfo('asc', type)
      }
    },
    handleCurrentChange() { },
    // 产品分组
    addType() {
      this.$refs.addTypeForm.validate(async (valid) => {
        if (valid) {
          const { data } = await addProductType(this.addTypeForm)
          if (data.code !== 0) return
          this.addTypeVisible = false
        }
      })

    },
    closeaddTypeDialog() {
      this.$refs.addTypeForm.resetFields();
    }
  }
}
</script>
<style lang='less' scoped>
.popContainer {
  // 二期需要删除
  // position: fixed;
  // top: 31%;
  // left: 4%;
  // right: 22.3%;
  // bottom: 0;
  // z-index: 999;
  // background: rgba(255, 255, 255, 1);
}
#adminProduct {
  padding: 0 25px;
  // text-align: center; // 到时需要删掉
  // margin-top: 20%; // 到时需要删掉
  // font-size: 15px; // 到时需要删掉

  .admin_content{ // 到时需要删掉
    img{
      width: 100%;
    }
  }
  .tabContent {
    color: #0066cc;
    cursor: pointer;
    img {
      vertical-align: bottom;
      width: 23px;
      margin-left: 25px;
    }
  }
  .addType {
    width: 160px;
  }
  .editGroup {
    width: 120px;
  }
  .save {
    line-height: 0 !important;
  }
}
</style>